import { render, staticRenderFns } from "./ClaimRewards.vue?vue&type=template&id=0eca960b&scoped=true&"
import script from "./ClaimRewards.vue?vue&type=script&lang=ts&"
export * from "./ClaimRewards.vue?vue&type=script&lang=ts&"
import style0 from "./ClaimRewards.vue?vue&type=style&index=0&id=0eca960b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eca960b",
  null
  
)

export default component.exports